import { render, staticRenderFns } from "./memberRule2.vue?vue&type=template&id=1adfe2f7&scoped=true&"
import script from "./memberRule2.vue?vue&type=script&lang=js&"
export * from "./memberRule2.vue?vue&type=script&lang=js&"
import style0 from "./memberRule2.vue?vue&type=style&index=0&id=1adfe2f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1adfe2f7",
  null
  
)

export default component.exports